const OUTLOOK_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 175" aria-hidden="true">
        <path d="M178.725 0H71.275A8.775 8.775 0 0 0 62.5 8.775v9.975l60.563 18.75L187.5 18.75V8.775A8.775 8.775 0 0 0 178.725 0z" fill="#0364b8" />
        <path d="M8.331 37.5h83.337A8.331 8.331 0 0 1 100 45.831v83.338a8.331 8.331 0 0 1-8.331 8.331H8.331A8.331 8.331 0 0 1 0 129.169V45.831A8.331 8.331 0 0 1 8.331 37.5z" fill="#0078d4" />
        <path d="M24.169 71.675a26.131 26.131 0 0 1 10.263-11.337 31.031 31.031 0 0 1 16.313-4.087 28.856 28.856 0 0 1 15.081 3.875 25.875 25.875 0 0 1 9.988 10.831 34.981 34.981 0 0 1 3.5 15.938 36.881 36.881 0 0 1-3.606 16.662 26.494 26.494 0 0 1-10.281 11.213 30 30 0 0 1-15.656 3.981 29.556 29.556 0 0 1-15.425-3.919 26.275 26.275 0 0 1-10.112-10.85 34.119 34.119 0 0 1-3.544-15.744 37.844 37.844 0 0 1 3.481-16.563z" fill="#fff" opacity=".9" />
    </svg>
);

const MICROSOFT_365_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 239.766" aria-hidden="true">
        <path d="M200 219.785l-.021-.012V20.591L128.615 0 .322 48.172 0 48.234.016 192.257l43.78-17.134V57.943l84.819-20.279-.012 172.285L.088 192.257l128.515 47.456v.053l71.376-19.753v-.227z" fill="#ea3e23" />
    </svg>
);

export default function OutlookCalendarLink({ href, label, icon }) {
    if (!href) return null;

    return (
        <a
            className="scheduler-calendar-button scheduler-calendar-button--outlook"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
        >
            <span className="scheduler-calendar-button__icon">{icon}</span>
            <span className="scheduler-calendar-button__label">{label}</span>
        </a>
    );
}

export { OUTLOOK_ICON, MICROSOFT_365_ICON };
